console.log("运行了config.js文件!!!")
window.APP_CONFIG = {
  API_BASE_URL: "http://192.168.100.200:50001/restful/rpc", // 内网环境下生效
};
